<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
        <path fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-width="2" d="M6 1v10m5-5H1"/>
    </svg>
</template>

<script>
export default {
    name: 'enroll-icon'
}
</script>